import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from './Cart';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import Header from './Header';
import Footer from './Footer';
import GiftSetModal from './GiftSetModal';
import WholesaleForm from './WholesaleForm';
import { FaBox, FaWineBottle, FaClock, FaFire, FaFish, FaHeart, FaGift, FaLeaf, FaHandshake } from 'react-icons/fa';

function HomeNew() {
  const { addToCart } = useCart();
  const [quizStep, setQuizStep] = useState(0);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [showWholesaleForm, setShowWholesaleForm] = useState(false);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  
  const giftSetProduct = {
    id: 'gift-set-premium',
    name: 'Подарочный набор Premium',
    price: '1990₽',
    category: 'giftSets',
    stock: 10
  };

  useEffect(() => {
    loadFeaturedProducts();
  }, []);

  const loadFeaturedProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'products'));
      const productsData = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(p => p.category !== 'giftSets' && p.stock > 0);
      
      const shuffled = productsData.sort(() => 0.5 - Math.random());
      setFeaturedProducts(shuffled.slice(0, 3));
    } catch (error) {
      console.error('Ошибка загрузки:', error);
    }
  };

  const quizQuestions = [
    {
      question: "Что вы обычно предпочитаете?",
      options: ["Сладкое", "Горькое", "Кислое", "Пряное"]
    },
    {
      question: "Для какого повода?",
      options: ["Для себя", "В подарок", "Для компании", "Для бара/ресторана"]
    }
  ];

  const getRecommendation = () => {
    if (quizAnswers[0] === "Сладкое") return "Морская волна";
    if (quizAnswers[0] === "Горькое") return "Кедровка";
    if (quizAnswers[0] === "Кислое") return "Красный лимон";
    return "Таёжный след";
  };

  return (
    <div className="App">
      <Header />

      {/* Hero Section - Mood Shot */}
      <section className="hero-new">
        <div className="hero-overlay"></div>
        <div className="hero-content-new">
          <h1 className="hero-title-new">Создай свой авторский напиток<br/>с характером Уссурийской тайги</h1>
          <p className="hero-subtitle-new">Не пей скучное. Настаивай своё.</p>
          <p className="hero-description">Готовые наборы из дикоросов Приморья. Просто добавь основу и подожди.</p>
          <Link to="/catalog" className="cta-button-new">Выбрать вкус</Link>
        </div>
      </section>

      {/* Brand Story Split */}
      <section className="brand-split-section">
        <div className="brand-split-content">
          <div className="brand-split-text">
            <h2>ДУХ ПРИМОРЬЯ – ОБЪЕДИНЯЕМ ВКУСЫ КУЛЬТУР</h2>
            <p>Совершите увлекательное путешествие по вкусам Дальнего Востока и создавайте свои собственные истории, наполненные ароматами морского бриза, таёжных трав и культурного разнообразия региона. Пусть каждый глоток станет напоминанием о природе, традициях и вдохновении, которое рождается на стыке культур.</p>
            <p>Даже начинающий винокур может легко создать уникальный напиток с превосходным качеством! Всё, что вам нужно, — качественный крепкий алкоголь и наш тщательно подобранный набор. Срок настаивания составляет от 2 дней до 2 недель — и вы сами выбираете глубину вкуса и насыщенность аромата.</p>
          </div>
          <div className="brand-split-image"></div>
        </div>
      </section>

      {/* Магия процесса */}
      <section id="process" className="process-section">
        <h2>Почувствуй себя алхимиком. Испортить — невозможно</h2>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-icon"><FaBox /></div>
            <h3>Засыпь</h3>
            <p>Высыпь содержимое крафтового пакета в банку</p>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-icon"><FaWineBottle /></div>
            <h3>Залей</h3>
            <p>Добавь 1-3 литра любой основы (водка/самогон/спирт)</p>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-icon"><FaClock /></div>
            <h3>Забудь</h3>
            <p>Убери в темное место на 2 недели. Встряхивай, когда вспомнишь</p>
          </div>
        </div>
      </section>

      {/* Вкус через текст - Featured Products */}
      <section className="featured-products">
        <h2>Популярные наборы</h2>
        <div className="products-grid-new">
          {featuredProducts.map(product => (
            <div key={product.id} className="product-card-new">
              <div className="product-images">
                {product.images && product.images.length > 0 ? (
                  <img src={product.images[0]} alt={product.name} />
                ) : (
                  <div className="product-placeholder-new"><FaLeaf /></div>
                )}
              </div>
              <div className="product-info-new">
                <h3>{product.name}</h3>
                {product.composition && (
                  <p className="product-composition">{product.composition}</p>
                )}
                {product.description && (
                  <p className="product-taste">{product.description}</p>
                )}
                <div className="product-footer">
                  <span className="product-price">{product.price}</span>
                  <button 
                    className="add-to-cart-btn" 
                    onClick={() => addToCart(product)}
                    disabled={!product.stock || product.stock === 0}
                  >
                    {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'В корзину'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{textAlign: 'center', marginTop: '3rem'}}>
          <Link to="/catalog" className="view-all-btn">Смотреть все вкусы</Link>
        </div>
      </section>

      {/* Сценарии потребления */}
      <section id="scenarios" className="scenarios-section">
        <h2>Выбери свой повод</h2>
        <div className="scenarios-grid">
          <div className="scenario-card">
            <div className="scenario-icon"><FaFire /></div>
            <h3>Для бани</h3>
            <p>Хвойные, мятные, освежающие</p>
            <Link to="/catalog" className="scenario-link">Смотреть →</Link>
          </div>
          <div className="scenario-card">
            <div className="scenario-icon"><FaFish /></div>
            <h3>Для охоты и рыбалки</h3>
            <p>Перцовка, хреновуха, крепкие и согревающие</p>
            <Link to="/catalog" className="scenario-link">Смотреть →</Link>
          </div>
          <div className="scenario-card">
            <div className="scenario-icon"><FaHeart /></div>
            <h3>Удивить девушку</h3>
            <p>Ягодные, сладкие, красивые цвета</p>
            <Link to="/catalog" className="scenario-link">Смотреть →</Link>
          </div>
          <div className="scenario-card">
            <div className="scenario-icon"><FaGift /></div>
            <h3>В подарок шефу</h3>
            <p>Премиальные наборы в элитной упаковке</p>
            <Link to="/catalog" className="scenario-link">Смотреть →</Link>
          </div>
        </div>
      </section>

      {/* Подарочные наборы */}
      <section id="gifts" className="gifts-section">
        <h2>Подарок, который не передарят</h2>
        <div className="gift-showcase">
          <div className="gift-image">
              <img src='/gifts.png' alt="Gift" />
          </div>
          <div className="gift-content">
            <h3>Готовое решение подарка</h3>
            <ul className="gift-features">
              <li>✓ Подарочная коробка</li>
              <li>✓ 2  бутылки</li>
              <li>✓ 2 рюмки</li>
              <li>✓ 2 набора трав</li>
              <li>✓ 2 этикетки</li>
              <li>✓ 2 камня для охлаждения</li>
              <li>✓ пакет с логотипом</li>
              <li>✓ поздравительная карточка</li>
              <li>✓ инструкция</li>
            </ul>
            <p className="gift-emotion">Эмоции от приготовления и гордость при дегустации</p>
            <button onClick={() => setShowGiftModal(true)} className="cta-button-new">Собрать подарок</button>
          </div>
        </div>
      </section>

      {/* Квиз */}
      <section className="quiz-section">
        <h2>Какая настойка тебе подойдет?</h2>
        {quizStep < quizQuestions.length ? (
          <div className="quiz-container">
            <h3>{quizQuestions[quizStep].question}</h3>
            <div className="quiz-options">
              {quizQuestions[quizStep].options.map((option, index) => (
                <button
                  key={index}
                  className="quiz-option"
                  onClick={() => {
                    setQuizAnswers({...quizAnswers, [quizStep]: option});
                    setQuizStep(quizStep + 1);
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="quiz-result">
            <h3>Вам подойдет: {getRecommendation()}</h3>
            <p>Этот набор идеально соответствует вашим предпочтениям!</p>
            <div className="quiz-actions">
              <Link to="/catalog" className="cta-button-new">Посмотреть в каталоге</Link>
              <button className="quiz-restart" onClick={() => {setQuizStep(0); setQuizAnswers({});}}>
                Пройти заново
              </button>
            </div>
          </div>
        )}
      </section>

      {/* Апсейл */}
      {/* <section className="upsell-section">
        <h2>Дополни свой заказ</h2>
        <div className="upsell-grid">
          <div className="upsell-card">
            <div className="upsell-icon">🏷️</div>
            <h3>Наклейки на бутылки</h3>
            <p>Напиши дату и название: "Настойка от Иваныча, выдержка 2024"</p>
            <span className="upsell-price">50₽</span>
          </div>
          <div className="upsell-card">
            <div className="upsell-icon">🧺</div>
            <h3>Мешочки для фильтрации</h3>
            <p>Чтобы в зубах не застревали травинки</p>
            <span className="upsell-price">80₽</span>
          </div>
          <div className="upsell-card">
            <div className="upsell-icon">🍾</div>
            <h3>Стильные бутылки</h3>
            <p>Перелей готовый продукт из банки в красивую тару</p>
            <span className="upsell-price">150₽</span>
          </div>
        </div>
      </section> */}

      {/* Оптовым клиентам */}
      <section className="wholesale-section">
        <div className="wholesale-content">
          <div className="wholesale-icon"><FaHandshake /></div>
          <h2>Работаем с оптовыми клиентами</h2>
          <p>Предлагаем выгодные условия для магазинов, ресторанов и дистрибьюторов</p>
          <div className="wholesale-benefits">
            <div className="wholesale-benefit">
              <strong>Индивидуальные цены</strong>
              <p>Специальные условия для оптовых покупателей</p>
            </div>
            <div className="wholesale-benefit">
              <strong>Быстрая доставка</strong>
              <p>Отправка по всей России</p>
            </div>
            <div className="wholesale-benefit">
              <strong>Поддержка</strong>
              <p>Персональный менеджер</p>
            </div>
          </div>
          <button onClick={() => setShowWholesaleForm(true)} className="cta-button">Оставить заявку</button>
        </div>
      </section>

      <Footer />
      
      <GiftSetModal
        isOpen={showGiftModal}
        onClose={() => setShowGiftModal(false)}
        onAddToCart={addToCart}
        giftSet={giftSetProduct}
      />
      
      <WholesaleForm
        isOpen={showWholesaleForm}
        onClose={() => setShowWholesaleForm(false)}
      />
    </div>
  );
}

export default HomeNew;
